import { baseURLEndpoint } from './constant'

export default {
  NAME: 'ngine',
  LOGIN_TITLE: ' ngine - Login | Unlimited Graphic Design Service',
  DOMAIN: baseURLEndpoint.substring(0, baseURLEndpoint.length - 6),
  REGISTER:
    baseURLEndpoint.substring(0, baseURLEndpoint.length - 6) + 'pricing-plans',
}
